import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { AvailablePickupsEffects } from './available-pickups.effects';
import { availablePickupsReducer } from './available-pickups.reducer';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature('availablePickups', availablePickupsReducer), EffectsModule.forFeature([AvailablePickupsEffects])],
    exports: [],
    providers: [],
})
export class AvailablePickupsStateModule {}
